import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./App.css";

import { AuthProvider } from "./HHC/components/Context/ContextAPI";
import { CallProvider } from "./HHC/components/Context/CallContext";

// ---------------------------------------------------------
// 🔥 GLOBAL FETCH OVERRIDE SETUP (Sare API calls yahan se guzrenge)
// ---------------------------------------------------------
// const originalFetch = window.fetch;

// window.fetch = async function (...args) {
//   try {
//     const response = await originalFetch(...args);

    
//     if (response.status === 403) {
//       console.warn("Global 403 Detected! Session Expired.");

    
//       localStorage.removeItem("token");

   
//       window.dispatchEvent(new CustomEvent("session-expired"));
//     }

//     return response;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };
// // ---------------------------------------------------------

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* <Provider store={store}>
      <App />
    </Provider> */}
    <AuthProvider>
      <CallProvider>
        <App />
      </CallProvider>
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
